import React, { useEffect } from "react";
import { useState } from "react";
import { getSiteRefrence } from "../../../api/endpoints/refrences";
import { authSelector } from "../../../store/selectors/index";
import { useSelector } from "react-redux";
import { message } from "antd";
import "./style.css";

export const ComponentToPrint = React.forwardRef((item, ref) => {
  const { access_token } = useSelector(authSelector);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [formattedDate, setFormattedDate] = useState("");

  const [total, setTotal] = useState();
  const [debitTotal, setDebitTotal] = useState();
  const [openingCashTotal, setOpeningCashTotal] = useState();

  const [openingCashColumn, setOpeningCashColumn] = useState([]);
  const [meterColumn, setMeterColumn] = useState([]);
  const [dailyDipColumn, setDailyDipColumn] = useState([]);
  const [lubeColumn, setLubeColumn] = useState([]);
  const [lubePreviousColumn, setLubePreviousColumn] = useState([]);
  const [lubeData, setLubeData] = useState([]);
  const [purchaseColumn, setPurchaseColumn] = useState([]);
  const [paymentColumn, setPaymentColumn] = useState([]);
  const [receiptColumn, setReceiptColumn] = useState([]);
  const [cardColumn, setCardColumn] = useState([]);
  const [creditSaleColumn, setCreditSaleColumn] = useState([]);
  const [sums, setSums] = useState({});
  const [rateDiffColumn, setRateDiffColumn] = useState([]);
  const [creditSaleRateWiseColumn, setCreditSaleRateWiseColumn] = useState([]);
  const [expenseColumn, setExpenseColumn] = useState([]);
  const [bankColumn, setBankColumn] = useState([]);
  const [bankStatusColumn, setBankStatusColumn] = useState([]);
  const [supplierColumn, setSupplierColumn] = useState([]);
  const [supplierStatusColumn, setSupplierStatusColumn] = useState([]);
  const [customerStatusColumn, setCustomerStatusColumn] = useState([]);

  useEffect(() => {
    const meterSaleItem = [];
    const dailyDipItem = [];
    const purchasesItem = [];
    const lubePreviousItem = [];
    const lubeItem = [];
    const paymentItem = [];
    const cardItem = [];
    const creditSaleItem = [];
    const receiptsItem = [];
    const creditRateDiffItem = [];
    const creditSaleRateWiseItem = [];
    const expenseItem = [];
    const bankItem = [];
    const supplierItem = [];
    const bankStatusItem = [];
    const supplierStatusItem = [];
    const customerStatusItem = [];

    const openingCashColumnItem = [];
    // const leftColumnItems = [];
    // const rightColumnItems = [];
    // const purchaseColumnItems = [];
    // const receiptColumnItems = [];

    item.item.forEach((item) => {
      console.log(item, "item");

      if (item.printOrder === 0) {
        openingCashColumnItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 1) {
        meterSaleItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 2) {
        dailyDipItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 3) {
        purchasesItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 4) {
        lubePreviousItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 5) {
        lubeItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 6) {
        cardItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 7) {
        receiptsItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 8) {
        creditSaleItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 9) {
        creditRateDiffItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 10) {
        creditSaleRateWiseItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 11) {
        expenseItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 12) {
        bankItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 13) {
        supplierItem.push(item); // UseItem push to accumulate items
      }
      if (item.printOrder === 15) {
        paymentItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 17) {
        bankStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 18) {
        supplierStatusItem.push(item); // Use push to accumulate items
      }
      if (item.printOrder === 19) {
        customerStatusItem.push(item); // Use push to accumulate items
      }
    });

    // Set the state of leftColumn and rightColumn
    setOpeningCashColumn(openingCashColumnItem);
    setMeterColumn(meterSaleItem);
    setDailyDipColumn(dailyDipItem);
    setPurchaseColumn(purchasesItem);
    setLubePreviousColumn(lubePreviousItem);
    setLubeColumn(lubeItem);
    setCardColumn(cardItem);
    setReceiptColumn(receiptsItem);
    setPaymentColumn(paymentItem);
    setCreditSaleColumn(creditSaleItem);
    setRateDiffColumn(creditRateDiffItem);
    setCreditSaleRateWiseColumn(creditSaleRateWiseItem);
    setExpenseColumn(expenseItem);
    setBankColumn(bankItem);
    setBankStatusColumn(bankStatusItem);
    setSupplierStatusColumn(supplierStatusItem);
    setCustomerStatusColumn(customerStatusItem);
    setSupplierColumn(supplierItem);
  }, [item.item]);

  // console.log(rateDiffColumn[0].credit, "ratediffcoloo");

  useEffect(() => {
    // Calculate the total sum using reduce

    const openCashSumcredit = openingCashColumn.reduce((accumulator, ele) => {
      const openCashSumcreditTotal = parseFloat(ele.credit);
      if (!isNaN(openCashSumcreditTotal) && isFinite(openCashSumcreditTotal)) {
        return accumulator + openCashSumcreditTotal;
      }
      // Handle non-numeric values as 0
      return accumulator;
    }, 0);

    const openCashSumdebit = openingCashColumn.reduce((accumulator, ele) => {
      const openCashSumdebitTotal = parseFloat(ele.debit);
      if (!isNaN(openCashSumdebitTotal) && isFinite(openCashSumdebitTotal)) {
        return accumulator + openCashSumdebitTotal;
      }
      // Handle non-numeric values as 0
      return accumulator;
    }, 0);
    console.log("credit", openCashSumcredit, openCashSumdebit, "debit");

    // Update the state with the total sum

    setOpeningCashTotal(
      (parseFloat(openCashSumcredit) - parseFloat(openCashSumdebit)).toFixed(2)
    );
  }, [openingCashColumn, openingCashTotal]);

  useEffect(() => {
    const calculatedSums = {};

    meterColumn.forEach((row) => {
      const { itemCode, itemName, quantity, saleRate } = row;

      if (!calculatedSums[itemCode]) {
        calculatedSums[itemCode] = {
          totalQuantity: 0,
          totalAmount: 0,
          itemName: itemName,
        };
      }

      calculatedSums[itemCode].totalQuantity += quantity;
      calculatedSums[itemCode].totalAmount += quantity * saleRate;
    });

    setSums(calculatedSums);
  }, [meterColumn]);

  useEffect(() => {
    // Calculate the final balance for each itemCode
    const combinedData = lubeColumn.map((lubeItem) => {
      const prevItem = lubePreviousColumn.find(
        (prev) => prev.itemCode === lubeItem.itemCode
      );
      const balanceQty = prevItem ? prevItem.balanceQty : 0;
      const saleQuantity = lubeItem.quantity;
      const saleRate = lubeItem.saleRate;
      const finalBalance = balanceQty - saleQuantity;

      return {
        itemCode: lubeItem.itemCode,
        itemName: lubeItem.itemName,
        saleRate: saleRate,
        preBalance: balanceQty,
        saleQuantity: saleQuantity,
        finalBalance: finalBalance,
      };
    });

    setLubeData(combinedData);
  }, [lubeColumn, lubePreviousColumn]);

  const getName = async (e) => {
    const result = await getSiteRefrence(access_token);
    if (result.success) {
      setSiteName(result.data.siteName);
      setSiteAddress(result.data.siteAddress);
    } else {
      message.error(result.message);
    }
  };

  let totalLubeSum = 0;
  let totalLubeQtySum = 0;
  lubeData.forEach((ele) => {
    totalLubeSum += ele.saleRate * ele.saleQuantity;
    totalLubeQtySum += ele.saleQuantity;
  });

  let salesAmountSum = 0;
  for (const [key, value] of Object.entries(sums)) {
    salesAmountSum += value.totalAmount;
  }

  let totalcreditRateDiffSum = 0;
  rateDiffColumn.forEach((ele) => {
    totalcreditRateDiffSum += ele.credit;
  });

  let totalSalesAmountSum =
    salesAmountSum + totalLubeSum - totalcreditRateDiffSum;

  let totalCardSum = 0;
  cardColumn.forEach((ele) => {
    totalCardSum += ele.debit;
  });

  let totalCreditSaleSum = 0;
  creditSaleColumn.forEach((ele) => {
    totalCreditSaleSum += ele.debit;
  });

  let totalReceivingSum = 0;
  receiptColumn.forEach((ele) => {
    totalReceivingSum += ele.credit;
  });

  let totalPaymentSum = 0;
  paymentColumn.forEach((ele) => {
    totalPaymentSum += ele.debit;
  });

  let totalExpenseSum = 0;
  expenseColumn.forEach((ele) => {
    totalExpenseSum += ele.debit;
  });

  let totalBankSum = 0;
  bankColumn.forEach((ele) => {
    totalBankSum += ele.debit;
  });

  let totalCustomerSum = 0;
  customerStatusColumn.forEach((ele) => {
    totalCustomerSum += ele.debit;
  });

  //Credit and Card Sale total
  let netCreditSale = parseFloat(totalCreditSaleSum) + parseFloat(totalCardSum);

  // Net Sale
  let netSale = parseFloat(totalSalesAmountSum) - parseFloat(netCreditSale);

  //Total Cash
  let totalCash = 0;
  totalCash =
    parseFloat(openingCashTotal) +
    parseFloat(netSale) +
    parseFloat(totalReceivingSum);

  let cashInHand =
    parseFloat(totalCash) -
    parseFloat(totalPaymentSum) -
    parseFloat(totalExpenseSum) -
    parseFloat(totalBankSum);

  useEffect(() => {
    getName();
  });

  useEffect(() => {
    function formatDate(inputDate) {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const formattedDate = new Date(inputDate).toLocaleDateString(
        undefined,
        options
      );
      return formattedDate;
    }

    const inputDate = meterColumn[0]?.enteredOn; // Use optional chaining to avoid errors if rightColumn[0] is undefined
    if (inputDate) {
      const formatted = formatDate(inputDate);
      setFormattedDate(formatted); // Set the formatted date in the state
    }
  }, [meterColumn]); // Listen for changes in rightColumn

  function formatValue(value) {
    // Check if the value is negative
    if (value < 0) {
      // If it's negative, wrap it in parentheses
      return `(${Math.abs(value)})`;
    } else {
      // If it's positive or zero, show it as is
      return `${value}`;
    }
  }

  let totalQuantity = 0;
  let totalAmount = 0;

  meterColumn.forEach((ele) => {
    totalQuantity += parseFloat(ele.quantity);
    totalAmount += parseFloat(ele.quantity) * parseFloat(ele.saleRate);
  });

  let itemTotals = {};

  const [itemDipTotals, setItemDipTotals] = useState({});
  useEffect(() => {
    // Initialize itemDipTotals when dailyDipColumn changes
    const totals = dailyDipColumn.reduce((acc, ele) => {
      const itemCode = ele.itemCode;
      acc[itemCode] = acc[itemCode] || {
        openingQty: 0,
        purchaseQty: 0,
        saleQty: 0,
        balanceQty: 0,
        gainQty: 0,
        closingQty: 0,
      };

      acc[itemCode].openingQty += parseFloat(ele.quantityOpening);
      acc[itemCode].purchaseQty += parseFloat(ele.quantity);
      acc[itemCode].saleQty += parseFloat(ele.balanceQty);
      acc[itemCode].balanceQty +=
        parseFloat(ele.quantityOpening) +
        parseFloat(ele.quantity) -
        parseFloat(ele.balanceQty);
      acc[itemCode].gainQty +=
        parseFloat(ele.quantityClosing) -
        (parseFloat(ele.quantityOpening) +
          parseFloat(ele.quantity) -
          parseFloat(ele.balanceQty));
      acc[itemCode].closingQty += parseFloat(ele.quantityClosing);

      return acc;
    }, {});

    setItemDipTotals(totals);
  }, [dailyDipColumn]);

  return (
    <div ref={ref}>
      <div className="flex flex-col items-center justify-center">
        <strong>
          {" "}
          <h1 style={{ fontSize: "30px" }}>{siteName}</h1>
        </strong>
        <strong>
          {" "}
          <h1 style={{ fontSize: "17px" }}>{siteAddress}</h1>
        </strong>
        <strong>
          <h1 style={{ fontSize: "17px" }}>
            Log Sheet {formattedDate || "Loading..."}
          </h1>
        </strong>
      </div>
      <div class="relative mt-5 overflow-x-auto">
        <div className="flex pl-2 pr-2">
          <div className="w-2/4">
            <table className="border-collapse border-2 ">
              <tbody>
                <tr>
                  <th className="border-2  px-4 py-2">Nozel Number</th>
                  {meterColumn.map((ele, i) => (
                    <td key={i} className="border-2  px-4 py-2">
                      {ele.nozelNumber}
                    </td>
                  ))}
                </tr>
                <tr>
                  <th className="border-2  px-4 py-2">Closing Reading</th>
                  {meterColumn.map((ele, i) => (
                    <td key={i} className="border-2  px-4 py-2">
                      {ele.meterEnding}
                    </td>
                  ))}
                </tr>
                <tr>
                  <th className="border-2  px-4 py-2">Opening Reading</th>
                  {meterColumn.map((ele, i) => (
                    <td key={i} className="border-2  px-4 py-2">
                      {ele.meterStarting}
                    </td>
                  ))}
                </tr>
                <tr>
                  <th className="border-2  px-4 py-2">Quantity</th>
                  {meterColumn.map((ele, i) => (
                    <td key={i} className="border-2  px-4 py-2">
                      {ele.quantity}
                    </td>
                  ))}
                </tr>
                <tr>
                  <th className="border-2  px-4 py-2">Testing</th>
                  {meterColumn.map((ele, i) => (
                    <td key={i} className="border-2  px-4 py-2">
                      {ele.meterCheck}
                    </td>
                  ))}
                </tr>
              </tbody>
              <tfoot>
                <tr className="border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td
                    colSpan={meterColumn.length + 1}
                    className="px-6 py-4 border-2 text-right"
                  >
                    <strong>Total Quantity:</strong> {totalQuantity.toFixed(2)}
                  </td>
                </tr>
                {Object.entries(itemTotals).map(
                  ([itemCode, itemTotal], index) => (
                    <tr
                      key={index}
                      className="border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4 border-2">
                        <strong>{`Total for Item ${itemCode}`}</strong>
                      </td>
                      <td className="border-2"></td>
                      <td className="px-6 py-4 border-2">
                        <strong>{itemTotal.quantity.toFixed(2)}</strong>
                      </td>
                      <td className="border-2"></td>
                      <td className="px-6 py-4 border-2">
                        <strong>{itemTotal.amount.toFixed(2)}</strong>
                      </td>
                    </tr>
                  )
                )}
              </tfoot>
            </table>
             <table>
              <thead>
                <tr className="bg-white dark:bg-gray-800">
                  <th className="px-6 py-4">Meter Sale</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Nozel Number</th>
                  <th className="px-6 py-4">Opening</th>
                  <th className="px-6 py-4">Ending</th>
                  <th className="px-6 py-4">Quantity</th>
                  <th className="px-6 py-4">Sale Rate</th>
                  <th className="px-6 py-4">Re Tank</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {meterColumn.length > 0 &&
                  meterColumn
                    .sort((a, b) => a.nozelOrder - b.nozelOrder)
                    .sort((a, b) => a.shift - b.shift)
                    .map((ele, i) => {
                      // Calculate row amount
                      const rowAmount = (
                        parseFloat(ele.quantity) * parseFloat(ele.saleRate)
                      ).toFixed(2);

                      // Update itemTotals with current row data
                      if (!itemTotals[ele.itemCode]) {
                        itemTotals[ele.itemCode] = {
                          quantity: 0,
                          amount: 0,
                        };
                      }

                      itemTotals[ele.itemCode].quantity += parseFloat(
                        ele.quantity
                      );
                      itemTotals[ele.itemCode].amount += parseFloat(rowAmount);

                      return (
                        <tr
                          key={i}
                          className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                        >
                          <td className="px-6 py-4">{ele.nozelNumber}</td>
                          <td className="px-6 py-4">{ele.meterStarting}</td>
                          <td className="px-6 py-4">{ele.meterEnding}</td>
                          <td className="px-6 py-4">{ele.quantity}</td>
                          <td className="px-6 py-4">{ele.saleRate}</td>
                          <td className="px-6 py-4">{ele.meterCheck}</td>
                          <td className="px-6 py-4">{rowAmount}</td>
                        </tr>
                      );
                    })}
                {/* New row for displaying totals */}

                {/* New row for displaying item-wise totals */}
                {Object.entries(itemTotals).map(
                  ([itemCode, itemTotal], index) => (
                    <tr
                      key={index}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td colSpan="3" className="px-6 py-4 text-right">
                        <strong>{`Total for Item ${itemCode}`}</strong>
                      </td>
                      <td className="px-6 py-4">
                        <strong>{itemTotal.quantity.toFixed(2)}</strong>
                      </td>
                      <td></td>
                      <td className="px-6 py-4">
                        <strong>{itemTotal.amount.toFixed(2)}</strong>
                      </td>
                    </tr>
                  )
                )}
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td colSpan="3" className="px-6 py-4 text-right">
                    <strong>Total</strong>
                  </td>
                  <td className="px-6 py-4">
                    <strong>{totalQuantity.toFixed(2)}</strong>
                  </td>
                  <td></td>
                  <td className="px-6 py-4">
                    <strong>{totalAmount.toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="flex pl-2 pr-2">
        <div className="w-2/4">
          <table>
            <thead>
              <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                <th className="">Daily Dip</th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <th className="px-6 py-4">Item Number</th>
                <th className="px-6 py-4">Tank Number</th>
                <th className="px-6 py-4">Opening Dip</th>
                <th className="px-6 py-4">Opening Qty</th>
                <th className="px-6 py-4">Purchase</th>
                <th className="px-6 py-4">Sale</th>
                <th className="px-6 py-4">Balance</th>
                <th className="px-6 py-4">Gain</th>
                <th className="px-6 py-4">Closing Dip</th>
                <th className="px-6 py-4">Closing Qty</th>
              </tr>
            </thead>
            <tbody>
              {dailyDipColumn.length > 0 &&
                dailyDipColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      {/* Your existing columns */}
                      <td className="px-6 py-4">{ele.itemCode}</td>
                      <td className="px-6 py-4">{ele.tankNumber}</td>
                      <td className="px-6 py-4">{ele.mmOpening}</td>
                      <td className="px-6 py-4">{ele.quantityOpening}</td>
                      <td className="px-6 py-4">{ele.quantity}</td>
                      <td className="px-6 py-4">{ele.balanceQty}</td>
                      <td className="px-6 py-4">
                        {ele.quantityOpening + ele.quantity - ele.balanceQty}
                      </td>
                      <td className="px-6 py-4">
                        {(
                          ele.quantityClosing -
                          (ele.quantityOpening + ele.quantity - ele.balanceQty)
                        ).toFixed(2)}
                      </td>
                      <td className="px-6 py-4">{ele.mmClosing}</td>
                      <td className="px-6 py-4">{ele.quantityClosing}</td>
                    </tr>
                  );
                })}
              {/* New row for displaying item-wise totals */}
              {Object.entries(itemDipTotals).map(
                ([itemCode, itemTotal], index) => (
                  <tr
                    key={index}
                    className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                  >
                    <td colSpan="3" className="px-6 py-4 text-right">
                      <strong>{`Total for Item ${itemCode}`}</strong>
                    </td>
                    {/* Add columns for each total you want to display */}
                    <td className="px-6 py-4">
                      {itemCode === "1" ? <strong>PMG</strong> : null}
                      {itemCode === "2" ? <strong>HSD</strong> : null}
                      {itemCode === "3" ? <strong>HOBC</strong> : null}
                      {/* <strong>{itemTotal.openingQty.toFixed(2)}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      {/* <strong>{itemTotal.purchaseQty.toFixed(2)}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      {/* <strong>{itemTotal.saleQty.toFixed(2)}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      {/* <strong>{itemTotal.balanceQty.toFixed(2)}</strong> */}
                    </td>
                    <td className="px-6 py-4">
                      <strong>{itemTotal.gainQty.toFixed(2)}</strong>
                    </td>
                    <td className="px-6 py-4">
                      {/* <strong>{itemTotal.closingQty.toFixed(2)}</strong> */}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
      {purchaseColumn.length > 0 ? (
        <div className="w-2/4 ">
          <table>
            <thead>
              <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                <th className="px-6 py-4">Purchase</th>
              </tr>
            </thead>
            <thead>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <th className="px-6 py-4">V.No</th>
                <th className="px-6 py-4">Item Code</th>
                <th className="px-6 py-4">Item Name</th>
                <th className="px-6 py-4">Supplier Name</th>
                <th className="px-6 py-4">Quantity</th>
                <th className="px-6 py-4">Amount</th>
              </tr>
            </thead>
            <tbody>
              {purchaseColumn.length > 0 &&
                purchaseColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.purchaseVoucherNo}</td>
                      <td className="px-6 py-4">{ele.itemCode}</td>
                      <td className="px-6 py-4">{ele.itemName}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.quantity}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
              {/* New row for displaying totals */}
            </tbody>
          </table>
        </div>
      ) : (
        <div></div>
      )}
      <div className="flex pl-2 pr-2">
        {lubeData.length > 0 ? (
          <div className="w-2/4 ">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Lube</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Item Code</th>
                  <th className="px-6 py-4">Item Name</th>
                  <th className="px-6 py-4">Opening Balance</th>
                  <th className="px-6 py-4">Sale Quantity</th>
                  <th className="px-6 py-4">Sale Rate</th>
                  <th className="px-6 py-4">Amount</th>
                  <th className="px-6 py-4">Closing Balance</th>
                </tr>
              </thead>
              <tbody>
                {lubeData.length > 0 &&
                  lubeData.map((ele, i) => {
                    return (
                      <tr
                        key={i}
                        className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                      >
                        <td className="px-6 py-4">{ele.itemCode}</td>
                        <td className="px-6 py-4">{ele.itemName}</td>
                        <td className="px-6 py-4">{ele.preBalance}</td>
                        <td className="px-6 py-4">{ele.saleQuantity}</td>
                        <td className="px-6 py-4">{ele.saleRate}</td>
                        <td className="px-6 py-4">
                          {ele.saleRate * ele.saleQuantity}
                        </td>
                        <td className="px-6 py-4">{ele.finalBalance}</td>
                      </tr>
                    );
                  })}
                {/* New row for displaying totals */}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="flex pl-2 pr-2">
        {cardColumn.length > 0 ? (
          <div className="w-2/4 ">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Cards</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">ID</th>
                  <th className="px-6 py-4">Name</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {cardColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
                {/* New row for displaying totals */}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {creditSaleRateWiseColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Credit Sale Rate Wise</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Item Name</th>
                  <th className="px-6 py-4">Sale Rate</th>
                  <th className="px-6 py-4">Quantity</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {creditSaleRateWiseColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.itemName}</td>
                      <td className="px-6 py-4">{ele.saleRate}</td>
                      <td className="px-6 py-4">{ele.quantity}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {paymentColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Payments</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">V.No.</th>
                  <th className="px-6 py-4">A/C No.</th>
                  <th className="px-6 py-4">A/C Name</th>
                  <th className="px-6 py-4">GL Code</th>
                  <th className="px-6 py-4">GL Description</th>
                  <th className="px-6 py-4">Description</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {paymentColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.voucherNumber}</td>
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.generalLedgerCode}</td>
                      <td className="px-6 py-4">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="px-6 py-4">{ele.description}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">
                    <strong>Total:</strong>
                  </td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4">
                    {" "}
                    <strong>{totalPaymentSum.toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {expenseColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Expenses</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">V.No.</th>
                  <th className="px-6 py-4">A/C No.</th>
                  <th className="px-6 py-4">A/C Name</th>
                  <th className="px-6 py-4">GL Code</th>
                  <th className="px-6 py-4">GL Description</th>
                  <th className="px-6 py-4">Description</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {expenseColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.voucherNumber}</td>
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.generalLedgerCode}</td>
                      <td className="px-6 py-4">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="px-6 py-4">{ele.description}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">
                    <strong>Total:</strong>
                  </td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4">
                    {" "}
                    <strong>{totalExpenseSum.toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {bankColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Bank</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">V.No.</th>
                  <th className="px-6 py-4">GL Code</th>
                  <th className="px-6 py-4">GL Description</th>
                  <th className="px-6 py-4">Description</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {bankColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.voucherNumber}</td>
                      <td className="px-6 py-4">{ele.generalLedgerCode}</td>
                      <td className="px-6 py-4">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="px-6 py-4">{ele.description}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">
                    <strong>Total:</strong>
                  </td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4"></td>
                  <td className="px-6 py-4">
                    {" "}
                    <strong>{totalBankSum.toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {supplierColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Supplier Payments</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">V.No.</th>
                  <th className="px-6 py-4">Party Id</th>
                  <th className="px-6 py-4">Party Name</th>
                  <th className="px-6 py-4">Description</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {supplierColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.voucherNumber}</td>
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.description}</td>
                      <td className="px-6 py-4">{ele.debit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex pl-2 pr-2">
        {receiptColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className=" bg-white  dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Receivings</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">V.No.</th>
                  <th className="px-6 py-4">A/C No.</th>
                  <th className="px-6 py-4">A/C Name</th>
                  <th className="px-6 py-4">GL Code</th>
                  <th className="px-6 py-4">GL Description</th>
                  <th className="px-6 py-4">Description</th>
                  <th className="px-6 py-4">Amount</th>
                </tr>
              </thead>
              <tbody>
                {receiptColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.voucherNumber}</td>
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">{ele.generalLedgerCode}</td>
                      <td className="px-6 py-4">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="px-6 py-4">{ele.description}</td>
                      <td className="px-6 py-4">{ele.credit}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      <div className="flex ">
        <div className="salesWidth p-2">
          <table>
            <thead>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <th className="px-6 py-4">Sales</th>
                <th className="px-6 py-4">Quantity</th>
                <th className="px-6 py-4">Amount</th>
              </tr>
            </thead>
            {Object.entries(sums).map(([key, value]) => (
              <tbody key={key}>
                <tr class="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td class="px-6 py-4">{value.itemName}</td>
                  <td class="px-6 py-4">{value.totalQuantity.toFixed(2)}</td>
                  <td class="px-6 py-4">{value.totalAmount.toFixed(2)}</td>
                </tr>
              </tbody>
            ))}
            <tbody>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">Lube</td>
                <td className="px-6 py-4">{totalLubeQtySum.toFixed(2)}</td>
                <td className="px-6 py-4">{totalLubeSum.toFixed(2)}</td>
              </tr>
              {rateDiffColumn.length > 0 &&
                rateDiffColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">Rate Diff</td>
                      <td className="px-6 py-4"></td>
                      <td className="px-6 py-4">{ele.credit}</td>
                    </tr>
                  );
                })}

              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Total </strong>
                </td>
                <td className="px-6 py-4"></td>
                <td className="px-6 py-4" colSpan="2">
                  <strong>{totalSalesAmountSum.toFixed(2)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="salesWidth p-2">
          <table>
            <thead>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <th className="px-6 py-4">Credits</th>
                <th className="px-6 py-4">Amount</th>
              </tr>
            </thead>

            <tbody>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">Credit Cards</td>
                <td className="px-6 py-4">{totalCardSum.toFixed(2)}</td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">Credit Sale</td>
                <td className="px-6 py-4">{totalCreditSaleSum.toFixed(2)}</td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Total </strong>
                </td>
                <td className="px-6 py-4" colSpan="2">
                  <strong>{netCreditSale.toFixed(2)}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <div>
          <strong>Cash Summary</strong>
        </div>
        <div className="salesWidth p-2">
          <table>
            <thead>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                {/* <th className="px-6 py-4">Credits</th>
                <th className="px-6 py-4">Amount</th> */}
              </tr>
            </thead>

            <tbody>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  {" "}
                  <strong> Opening Cash </strong>
                </td>
                <td className="px-6 py-4">{openingCashTotal}</td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  {" "}
                  <strong>Net Sales</strong>
                </td>
                <td className="px-6 py-4">
                  {netSale.toFixed(2)}
                  {/* {totalSalesAmountSum.toFixed(2) - totalCardSum.toFixed(2)}{" "} */}
                </td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Receivings</strong>
                </td>
                <td className="px-6 py-4">{totalReceivingSum.toFixed(2)}</td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Total Cash</strong>
                </td>
                <td className="px-6 py-4">
                  {parseFloat(totalCash).toFixed(2)}
                </td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Expense</strong>
                </td>
                <td className="px-6 py-4">
                  {parseFloat(totalExpenseSum).toFixed(2)}
                </td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Bank Deposit</strong>
                </td>
                <td className="px-6 py-4">
                  {parseFloat(totalBankSum).toFixed(2)}
                </td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Payments</strong>
                </td>
                <td className="px-6 py-4">
                  {parseFloat(totalPaymentSum).toFixed(2)}
                </td>
              </tr>
              <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                <td className="px-6 py-4">
                  <strong>Cash In Hand</strong>
                </td>
                <td className="px-6 py-4">
                  {parseFloat(cashInHand).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className="flex pl-2 pr-2">
        {bankStatusColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Bank Status</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Name</th>
                  <th className="px-6 py-4">Receivable</th>
                  <th className="px-6 py-4">Payable</th>
                </tr>
              </thead>
              <tbody>
                {bankStatusColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">
                        {ele.generalLedgerDescription}
                      </td>
                      <td className="px-6 py-4">
                        {ele.debit >= 0 ? ele.debit : 0}
                      </td>
                      <td className="px-6 py-4">
                        {ele.debit < 0 ? -ele.debit : 0}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>
      <div className="flex pl-2 pr-2">
        {supplierStatusColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Supplier Status</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Name</th>
                  <th className="px-6 py-4">Receivable</th>
                  <th className="px-6 py-4">Payable</th>
                </tr>
              </thead>
              <tbody>
                {supplierStatusColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">
                        {ele.debit >= 0 ? ele.debit : 0}
                      </td>
                      <td className="px-6 py-4">
                        {ele.debit < 0 ? -ele.debit : 0}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div>

      {/* <div className="flex pl-2 pr-2">
        {customerStatusColumn.length > 0 ? (
          <div className="w-2/4">
            <table>
              <thead>
                <tr className="bg-white dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Customer Status</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">A/C</th>
                  <th className="px-6 py-4">Name</th>
                  <th className="px-6 py-4">Receivable</th>
                  <th className="px-6 py-4">Payable</th>
                </tr>
              </thead>
              <tbody>
                {customerStatusColumn.map((ele, i) => {
                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      <td className="px-6 py-4">{ele.partyId}</td>
                      <td className="px-6 py-4">{ele.partyName}</td>
                      <td className="px-6 py-4">
                        {ele.debit >= 0 ? ele.debit : ""}
                      </td>
                      <td className="px-6 py-4">
                        {ele.debit < 0 ? -ele.debit : ""}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div></div>
        )}
      </div> */}

      <div className="flex pl-2 pr-2">
        {(creditSaleColumn.length > 0 || customerStatusColumn.length > 0) && (
          <div className="w-3/4">
            <table>
              <thead>
                <tr className=" bg-white dark:bg-gray-800 dark:border-gray-700">
                  <th className="px-6 py-4">Credit Sale & Customer Status</th>
                </tr>
              </thead>
              <thead>
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  {/* <th className="px-6 py-4">A/C No.</th> */}
                  <th className="px-6 py-4">A/C Name</th>
                  <th className="px-6 py-4">To Day</th>
                  <th className="px-6 py-4">Balance</th>
                  {/* <th className="px-6 py-4">Receivable</th> */}
                </tr>
              </thead>
              <tbody>
                {creditSaleColumn.map((creditSale, i) => {
                  // Find the corresponding customerStatus element based on partyId
                  const customerStatus = customerStatusColumn.find(
                    (customer) => customer.partyId === creditSale.partyId
                  );

                  return (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      {/* <td className="px-6 py-4">{creditSale.partyId}</td> */}
                      <td className="px-6 py-4">{creditSale.partyName}</td>
                      <td className="px-6 py-4">{creditSale.debit}</td>
                      <td className="px-6 py-4">{customerStatus.debit}</td>
                    </tr>
                  );
                })}

                {customerStatusColumn
                  .filter(
                    (customer) =>
                      !creditSaleColumn.some(
                        (creditSale) => creditSale.partyId === customer.partyId
                      )
                  )
                  .map((customerStatus, i) => (
                    <tr
                      key={i}
                      className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700"
                    >
                      {/* <td className="px-6 py-4">{customerStatus.partyId}</td> */}
                      <td className="px-6 py-4">{customerStatus.partyName}</td>
                      <td className="px-6 py-4"></td>
                      <td className="px-6 py-4">
                        {customerStatus.debit < 0
                          ? `(${Math.abs(customerStatus.debit)})`
                          : customerStatus.debit}
                      </td>
                    </tr>
                  ))}
                <tr className="bg-white border-2 dark:bg-gray-800 dark:border-gray-700">
                  <td className="px-6 py-4">
                    <strong>Total:</strong>
                  </td>

                  <td className="px-6 py-4">
                    {" "}
                    <strong>{totalCreditSaleSum.toFixed(2)}</strong>
                  </td>
                  <td className="px-6 py-4">
                    {" "}
                    <strong>{totalCustomerSum.toFixed(2)}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
});
